import React from "react";
import "./Resources.css";
import { Typography, Avatar, ListItem, List, Stack } from "@mui/joy";
import DescriptionIcon from "@mui/icons-material/Description";
import BorderColorIcon from "@mui/icons-material/BorderColor";

const TypesOfLegislation = () => {
  return (
    <Stack direction={"column"} padding={8} spacing={4}>
      <Stack direction={"column"} spacing={1}>
        <Typography level="h2" sx={{ textAlign: "center" }}>
          Types of Legislation
        </Typography>
        <Typography level="body-md" sx={{ textAlign: "center" }}>
          Understanding how laws are made is the first step to effective
          activism.
        </Typography>
      </Stack>
      <List
        component={Stack}
        spacing={0}
        sx={{
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "flex-start",
          gap: "12px",
          alignItems: "stretch",
        }}
      >
        <ListItem sx={{ flexDirection: "column", flex: 1 }}>
          <Avatar color="primary">
            <BorderColorIcon />
          </Avatar>
          <Typography level="title-lg" sx={{ textAlign: "center" }}>
            Bills
          </Typography>
          <Typography level="body-md" sx={{ textAlign: "left" }}>
            A bill is a proposed law. It can be temporary or permanent and can
            apply to the whole country or just a specific group.
            <ul>
              <li>
                Bills that start in the House of Representatives are labeled{" "}
                <b>“H.R.”</b> followed by a number.
              </li>
              <li>
                For a bill to become a law, both the House and Senate must
                approve the same version.
              </li>
              <li>
                Once approved, the bill is sent to the President to be signed
                into law or rejected.
              </li>
            </ul>
          </Typography>
        </ListItem>
        <ListItem sx={{ flexDirection: "column", flex: 1 }}>
          <Avatar color="primary">
            <DescriptionIcon />
          </Avatar>
          <Typography level="title-lg" sx={{ textAlign: "center" }}>
            Joint Resolutions
          </Typography>
          <Typography level="body-md" sx={{ textAlign: "left" }}>
            A joint resolution is very similar to a bill and follows the same
            process to become law.
            <ul>
              <li>
                These can start in either the House or Senate and are labeled{" "}
                <b>“H.J.Res.”</b> if from the House.
              </li>
              <li>
                If a joint resolution is about{" "}
                <b>changing the U.S. Constitutions</b>, it must be approved by
                two-thirds of both chambers and then sent to the states for
                approval.
              </li>
              <li>
                <b>The President does not sign constitutional amendments.</b>
              </li>
            </ul>
          </Typography>
        </ListItem>
        <ListItem sx={{ flexDirection: "column", flex: 1 }}>
          <Avatar color="primary">
            <DescriptionIcon />
          </Avatar>
          <Typography level="title-lg" sx={{ textAlign: "center" }}>
            Concurrent Resolutions
          </Typography>
          <Typography level="body-md" sx={{ textAlign: "left" }}>
            These resolutions affect <b>both the House and Senate</b> but do not
            become law.
            <ul>
              <li>
                They deal with things like shared rules or opinions of Congress.
              </li>
              <li>
                They are labeled <b>“H.Con.Res.”</b> and must be approved by
                both chambers.
              </li>
              <li>
                The President does <b>not</b> need to approve them.
              </li>
            </ul>
          </Typography>
        </ListItem>
        <ListItem sx={{ flexDirection: "column", flex: 1 }}>
          <Avatar color="primary">
            <DescriptionIcon />
          </Avatar>
          <Typography
            level="title-lg"
            sx={{ textAlign: "center", width: "100%" }}
          >
            Simple Resolutions
          </Typography>
          <Typography level="body-md" sx={{ textAlign: "left", width: "100%" }}>
            These resolutions only apply to <b>one chamber</b> (either the House
            or Senate).
            <ul>
              <li>
                They are used for internal matters like setting rules or making
                official statements.
              </li>
              <li>
                House resolutions are labeled <b>“H.Res.”</b> and do <b>not</b>{" "}
                go to the President.
              </li>
            </ul>
          </Typography>
        </ListItem>
      </List>
    </Stack>
  );
};

export default TypesOfLegislation;
